module.exports = __webpack_public_path__ + "static/media/patrol-bushes_1.5dc17b19.jpg";